/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component, { type ComponentAttrs } from 'flarum/common/Component';
import type Article from 'flarum/orell-articles/models/Article';
import type Mithril from 'mithril';

export interface ArticleStatusAttrs extends ComponentAttrs {
	article: Article;
}

export default class ArticleStatus<CustomAttrs extends ArticleStatusAttrs = ArticleStatusAttrs> extends Component<CustomAttrs> {
	view(): Mithril.Children {
		const { article } = this.attrs;

		const status = article.status();
		const name = status ? status.name() : null;

		if (!name) return <div></div>;

		return <div className="ArticleStatus">{name}</div>;
	}
}
